import { connect } from 'react-redux';

import Report from './Report.js';
// import { redux as apiRedux } from '../api';

const mapStateToProps = state => {
  return { user: state.api.user };
};

const mapDispatchToProps = dispatch => {
  return {};
};

const ConnectedReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(Report);

export default ConnectedReport;
